// extracted by mini-css-extract-plugin
module.exports = {"card-hover":"sister-card_card-hover__2Gky-","more":"sister-card_more__E66W_","title":"sister-card_title__2h1Rq","desc":"sister-card_desc__21Wnk"};